/* eslint max-len: 0 */

import React from 'react';
import { Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

type Props = {
  readonly company?: string;
  readonly fromDashboard?: string;
};

const HelpAdminMnp = (props: Props) => {
  return (
    <div style={{ padding: 5 }}>
      <Typography variant="body1" style={{ marginTop: 15, marginBottom: 10 }}>
        {props.fromDashboard ? (
          <Button component={Link} to="/mnp/mobileCountryCodes" size="small" color="secondary">
            <FormattedMessage id="nav.mnp" />
          </Button>
        ) : undefined}
      </Typography>
      <div style={{ paddingLeft: 15, paddingRight: 15 }}>
        <Typography variant="subtitle2" align="justify">
          <FormattedMessage id="help.administration.mnp.1" />
        </Typography>
        <p></p>
        <Typography variant="subtitle2" align="justify">
          <FormattedMessage id="mnp.mobileCountryCodes.label" />
        </Typography>
        <p></p>
        <Typography variant="body2" align="justify">
          <FormattedMessage id="help.administration.mnp.2" />
        </Typography>
        <p></p>
        <Typography variant="body2" align="justify">
          <FormattedMessage id="help.administration.mnp.3" />
        </Typography>
        <p></p>
        <Typography variant="body2" align="justify">
          <FormattedMessage id="help.administration.mnp.4" />
        </Typography>
        <p></p>
        <Typography variant="subtitle2" align="justify">
          <FormattedMessage id="mnp.mobileNetworkNames.label" />
        </Typography>
        <p></p>
        <Typography variant="body2" align="justify">
          <FormattedMessage id="help.administration.mnp.5" />
        </Typography>
        <p></p>
        <Typography variant="body2" align="justify">
          <FormattedMessage id="help.administration.mnp.6" />
        </Typography>
        <p></p>
        <Typography variant="body2" align="justify">
          <FormattedMessage id="help.administration.mnp.7" />
        </Typography>
        <p></p>
        <Typography variant="subtitle2" align="justify">
          <FormattedMessage id="mnp.lookup.history.label" />
        </Typography>
        <p></p>
        <Typography variant="body2" align="justify">
          <FormattedMessage id="help.administration.mnp.8" />
        </Typography>
        <p></p>
        <Typography variant="subtitle2" align="justify">
          <FormattedMessage id="nav.mnp.lookupNumber" />
        </Typography>
        <p></p>
        <Typography variant="body2" align="justify">
          <FormattedMessage id="help.administration.mnp.9" />
        </Typography>
        <p></p>
        <Typography variant="body2" align="justify">
          <FormattedMessage id="help.administration.mnp.10" />
        </Typography>
      </div>
    </div>
  );
};

export default HelpAdminMnp;
